export enum UGCViewType {
  FeedPost       = 1,
  ArticlePost    = 2,
  DiscoveryVideo = 3,
}